import { array, number, object, string } from 'yup';

import { containerFormValidations } from './translations';
import type { Container } from './types';

export const createValidationSchema = (containers: Record<string, Container>) =>
  object().shape(
    Object.fromEntries(
      Object.keys(containers).map((containerId) => [
        containerId,
        object().shape({
          id: string().required('Id is required'),
          description: string().required(containerFormValidations.description),
          hsCodes: array()
            .min(1, containerFormValidations.hsCodeAtLeastOne)
            .test('are-valid-hs-codes', containerFormValidations.hsCodeFormat, (hsCodes) => {
              if (!hsCodes) return true;

              return hsCodes.every((hsCode) => {
                return string()
                  .matches(/^\d{6,}$/, {
                    message: containerFormValidations.hsCodeFormat
                  })
                  .isValidSync(hsCode);
              });
            }),
          loose: object().shape({
            grossWeight: object().shape(
              {
                value: number()
                  .positive(containerFormValidations.weightGreaterThanZero)
                  .required()
                  .when('metric', {
                    is: (metric: string) => !!metric,
                    then: (schema) => schema.required(containerFormValidations.weightValue)
                  }),
                metric: string().when('value', {
                  is: (value: number) => !!value,
                  then: (schema) => schema.required(containerFormValidations.weightUnit)
                })
              },
              [['value', 'metric']]
            ),
            quantity: number()
              .positive(containerFormValidations.quantityGreaterThanZero)
              .required(containerFormValidations.quantity),
            type: string().required(containerFormValidations.cargoType),
            volume: number().positive(containerFormValidations.cbmGreaterThanZero).required(containerFormValidations.cbm)
          }),
          marksAndNumbers: string().required(containerFormValidations.marksAndNumbers),
          number: string()
            .required(containerFormValidations.containerNumber)
            .matches(/^[A-Z]{3}[UJZ]\d{7}$/, containerFormValidations.containerValid),
          packagingTypes: string().required(containerFormValidations.packagingTypes),
          sealNumber: string().required(containerFormValidations.sealNumber)
        })
      ])
    )
  );
